var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcalamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23432 2.21665L2.17599 14C2.03046 14.252 1.95346 14.5377 1.95264 14.8288C1.95183 15.1198 2.02723 15.4059 2.17134 15.6588C2.31545 15.9116 2.52326 16.1223 2.77408 16.2699C3.02489 16.4174 3.30999 16.4968 3.60099 16.5H17.7177C18.0087 16.4968 18.2937 16.4174 18.5446 16.2699C18.7954 16.1223 19.0032 15.9116 19.1473 15.6588C19.2914 15.4059 19.3668 15.1198 19.366 14.8288C19.3652 14.5377 19.2882 14.252 19.1427 14L12.0843 2.21665C11.9358 1.97174 11.7266 1.76925 11.477 1.62872C11.2274 1.48819 10.9458 1.41437 10.6593 1.41437C10.3729 1.41437 10.0913 1.48819 9.84166 1.62872C9.59205 1.76925 9.38288 1.97174 9.23432 2.21665Z",
    stroke: "#1a54da",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6592 6.5V9.83333",
    stroke: "#1a54da",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6592 13.1667H10.6675",
    stroke: "#1a54da",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcalamation);
export default __webpack_public_path__ + "static/media/excalamation.7527fc769b8103da7eb4ba9f823a852c.svg";
export { ForwardRef as ReactComponent };